import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { useClientUser } from '@/hooks';
import { QUERY_SHIPPERS_BY_ORGANIZATION } from '../graphql/queries';

// Shippers in an asset-heavy carrier admin's organization, for creating orders on
// their behalf. Entries mirror the `shipping_partners` shape ({ shipper_id, shipper:
// { business_name } }) so the shipper dropdowns and the OrderCard lookup can consume
// either source interchangeably. Empty unless the user is a carrier admin.
export const useOrgShippers = () => {
    const { isCarrierAdmin, organization_id } = useClientUser();

    const { data } = useQuery(QUERY_SHIPPERS_BY_ORGANIZATION, {
        variables: { organization_id },
        skip: !isCarrierAdmin || !organization_id,
    });

    return useMemo(
        () =>
            (data?.results || []).map((shipper) => ({
                shipper_id: shipper.client_id,
                shipper: { business_name: shipper.business_name },
            })),
        [data]
    );
};
